export default __webpack_public_path__ + "static/media/flagshipProjectPic.b94ac2ae.png";